export const MAIN_CLASS_NAME = 'card-content';
export const COLUMN_CLASS_NAME = `${MAIN_CLASS_NAME}__column`;
export const LIST_CLASS_NAME = `${COLUMN_CLASS_NAME}_list`;
export const ITEM_CLASS_NAME = `${COLUMN_CLASS_NAME}__item`;
